const RunningSvg = ({ width = 20, height = 20 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      width={width}
      height={height}
      viewBox="0 0 256 256"
      xmlSpace="preserve">
      <defs></defs>
      <g
        style={{
          stroke: 'none',
          strokeWidth: 0,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: 'none',
          fillRule: 'nonzero',
          opacity: 1
        }}
        transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
        <path
          d="M 45 0 C 20.147 0 0 20.147 0 45 c 0 24.853 20.147 45 45 45 s 45 -20.147 45 -45 C 90 20.147 69.853 0 45 0 z M 58.094 19.068 c 2.761 0 4.999 2.238 4.999 4.999 c 0 2.761 -2.238 4.999 -4.999 4.999 c -2.761 0 -4.999 -2.238 -4.999 -4.999 C 53.095 21.305 55.333 19.068 58.094 19.068 z M 29.174 36.303 l 8.231 -11.644 c 0.702 -0.991 2.012 -1.335 3.11 -0.817 l 4.208 1.99 c 1.248 0.59 1.782 2.081 1.191 3.329 c -0.591 1.248 -2.082 1.78 -3.329 1.191 l -2.31 -1.092 l -7.02 9.929 c -0.487 0.689 -1.259 1.057 -2.043 1.057 c -0.499 0 -1.003 -0.148 -1.441 -0.458 C 28.645 38.99 28.377 37.43 29.174 36.303 z M 53.128 55.96 l -9.838 13.916 c -0.487 0.688 -1.259 1.057 -2.043 1.057 c -0.499 0 -1.003 -0.148 -1.441 -0.459 c -1.127 -0.797 -1.395 -2.356 -0.598 -3.484 l 8.121 -11.485 l -2.229 -1.054 c -1.249 -0.59 -1.782 -2.08 -1.192 -3.328 c 0.59 -1.248 2.081 -1.781 3.329 -1.191 l 4.92 2.326 c 0.668 0.315 1.162 0.91 1.35 1.625 C 53.692 54.596 53.555 55.356 53.128 55.96 z M 64.994 44.97 H 52.973 c -1.228 0 -2.273 -0.891 -2.469 -2.104 l -0.807 -5.027 L 27.048 69.876 c -0.487 0.688 -1.259 1.057 -2.043 1.057 c -0.499 0 -1.003 -0.148 -1.441 -0.459 c -1.127 -0.797 -1.395 -2.356 -0.598 -3.484 l 26.188 -37.042 c 0.002 -0.003 0.005 -0.005 0.007 -0.008 c 0.096 -0.134 0.204 -0.26 0.325 -0.373 c 0 0 0 0 0.001 -0.001 c 0.118 -0.111 0.248 -0.21 0.387 -0.297 c 0.07 -0.043 0.146 -0.073 0.219 -0.109 c 0.102 -0.05 0.205 -0.097 0.315 -0.133 c 0.124 -0.041 0.249 -0.079 0.377 -0.1 c 0.005 -0.001 0.01 -0.003 0.015 -0.004 c 0.058 -0.009 0.115 -0.005 0.173 -0.01 c 0.101 -0.009 0.202 -0.021 0.305 -0.018 c 0.081 0.003 0.158 0.018 0.237 0.028 c 0.082 0.01 0.164 0.016 0.246 0.035 c 0.086 0.02 0.168 0.053 0.251 0.081 c 0.071 0.024 0.142 0.043 0.211 0.074 c 0.101 0.045 0.193 0.104 0.287 0.162 c 0.043 0.027 0.089 0.044 0.13 0.074 c 0.004 0.003 0.006 0.006 0.01 0.009 c 0.266 0.19 0.495 0.431 0.67 0.713 c 0.028 0.045 0.045 0.095 0.07 0.141 c 0.068 0.126 0.127 0.258 0.173 0.397 c 0.04 0.122 0.078 0.245 0.099 0.372 c 0.001 0.005 0.003 0.009 0.004 0.014 l 1.44 8.976 h 9.891 c 1.381 0 2.5 1.119 2.5 2.5 S 66.375 44.97 64.994 44.97 z"
          style={{
            stroke: 'none',
            strokeWidth: 0,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fill: 'rgb(0,0,0)',
            fillRule: 'nonzero',
            opacity: 1
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};

export default RunningSvg;
